import { reactive, computed } from 'vue';
import { debounce } from '@/utils/index';

const { width: screenWidth } = window.screen;

export default function useTooltip() {
    const taskInfo = reactive({
        startTime: null,
        endTime: null,
        ifShow: null,
        taskName: null,
        completionDegree: null,
        scheduledStartTime: null,
        scheduledEndTime: null,
        actualReleaseStartTime: null,
        actualReleaseEndTime: null,
        x: null,
        y: null,
        display: "none",
    });

    const taskInfoStyle = computed(() => {
        return `left: ${taskInfo.x}px; top: ${taskInfo.y}px; display: ${taskInfo.display}`;
    });

    const showTaskInfo = (e) => {
        const { target } = e;
        const record = JSON.parse(target.getAttribute("data-record"));

        Object.keys(taskInfo).forEach((key) => {
            if (record[key]) {
                taskInfo[key] = record[key];
            } else {
                taskInfo[key] = '';
            }
        });

        taskInfo.display = "block";
    };

    const updateTaskInfo = debounce((e) => {
        const { pageX, pageY } = e;

        taskInfo.x = pageX - 150;

        taskInfo.y = pageY - 160;

        taskInfo.x =
            taskInfo.x + 340 > screenWidth ? taskInfo.x - 150 : taskInfo.x;
    }, 1);

    const hideTaskInfo = (e) => {
        taskInfo.display = "none";
    };
    return {
        taskInfo,
        taskInfoStyle,
        showTaskInfo,
        updateTaskInfo,
        hideTaskInfo,
    }
}
